import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {Unveil} from '@homeaway/react-unveil';


function HitThumbnail({galleryUrl, url, className}) {
    const classname = classnames('card__figure scratchpad-hit-wrapper', className);
    let imageUrl = url || galleryUrl;

    return (
        <Unveil
            className={classname}
            offset={500}
        >
            <div
                className="scratchpad-hit-thumbnail component--translucent"
                style={{backgroundImage: `url(${imageUrl})`}}
            />
        </Unveil>
    );
}

HitThumbnail.propTypes = {
    className: PropTypes.string,
    galleryUrl: PropTypes.string.isRequired,
    url: PropTypes.string
};

export default HitThumbnail;



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/HitThumbnails/HitThumbnail/HitThumbnail.js